// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fe3b160c","455":"7b374138","977":"c2bee376"}[chunkId] + ".chunk.js";
};